import { useEffect } from "react";
import CatalogDocument from "../../components/catalogs/CatalogDocument";
import "../../styles/catalog.css";
import type { CatalogBrandOption, CatalogDetail, FeatureFlags } from "../../types";

type Props = {
  catalog: CatalogDetail;
  brands: CatalogBrandOption[];
  feature_flags?: FeatureFlags;
};

export default function CatalogPrint({ catalog, brands, feature_flags }: Props) {
  const areBrandsEnabled = feature_flags?.brands_enabled ?? true;
  const brand = areBrandsEnabled ? brands.find((option) => option.id === catalog.brand_id) ?? null : null;

  useEffect(() => {
    let printed = false;
    const triggerPrint = () => {
      if (printed) return;
      printed = true;
      window.print();
    };

    const images = Array.from(document.images);
    const ready = images.map((image) =>
      typeof image.decode === "function" ? image.decode().catch(() => undefined) : Promise.resolve(),
    );

    const fallback = window.setTimeout(triggerPrint, 10000);
    void Promise.allSettled(ready).then(triggerPrint);

    return () => window.clearTimeout(fallback);
  }, []);

  return (
    <div className="catalog-print-root">
      <div className="catalog-print-actions no-print">
        <button type="button" className="btn btn-primary btn-sm" onClick={() => window.print()}>Drukuj</button>
        <button type="button" className="btn btn-sm" onClick={() => window.close()}>Zamknij</button>
      </div>
      <CatalogDocument name={catalog.name} brand={brand} layout={catalog.layout} items={catalog.items} />
    </div>
  );
}
